<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/banner3.png" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>集团介绍</h3>
            <p>Group Introduction</p>
          </dt>
          <dd class="w25">
            <router-link to="Intro"><span>企业简介</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Architecture"><span>企业架构</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Culture"><span>企业文化</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="DevelopmentCourse" class="active"><span>发展历程</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w25">
            <router-link to="Responsibility"><span>社会责任</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>

      <div class="news-right">
        <div class="news-bread">
          <h2>集团介绍</h2>/<i>发展历程</i>
        </div>
        <div class="development-course">
          <h3>“华剑风云录”大事年表</h3>
          <el-timeline>
            <el-timeline-item v-for="item in courseList" :key="item.id" :timestamp="item.title" placement="top" type="success" size="large" icon="el-icon-s-promotion">
              <el-card>
                <p v-html="turn(item.content)"></p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
         <!-- 回到顶部 -->
        <el-backtop></el-backtop>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'DevelopmentCourse',
    data() {
      return {
        courseList: []
      }
    },
    mounted() {
      // 请求发展历程列表
      // axios.get(global_msg.baseUrl + 'ntWebsiteinfo/findByAll?xtId=526&nwiIsShow=1&uiId=1&nwcId=27&page=1&rows=15').then((response) => {
      //   this.courseList = response.data.rows.reverse();//倒序，将数组从尾到头输出
      // })
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=企业历程').then((response) => {
        this.courseList = response.data.subject.result.reverse();//倒序，将数组从尾到头输出
      });
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    methods: {
      turn(data){
        return data.replace(/(\r\n|\n|\r)/gm, "<br />")
      }
    }
  }
</script>

<style scoped>
  .development-course {
    margin: 0 10px;
  }

  .development-course h3 {
    display: block;
    line-height: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/DevelopmentCourse.vue